export default {
    data() {
        return {

        }

    },
    created: function() {},
    methods: {
        /**
         * type: post/get
         * endpoint: url
         * header: json
         * payload: data
         * 
         * Calls an api. Used for communication with backend, so that we dont need to add the authorization-header manually on
         * every request.
         */
        async callApi(endpoint, type = 'get', payload = {}, header = null, showError = true, customEndpoint = false) {
            //    alert("callapimixin")
            var promise = new Promise(function(resolve, reject) {
                let headerData = header;

                //Only add authorization-header when backend is called
                if (header == null && !customEndpoint) {
                    headerData = {
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.bearertoken
                    }
                }
                let apiUrl = this.$backendURL + endpoint;
                if (customEndpoint) {
                    apiUrl = endpoint
                }
                if (type == 'post') {
                    this.$axios.post(apiUrl, payload, {
                        headers: headerData
                    }).then(function(result) {
                        console.log("resolve post")
                        resolve(result);

                    }.bind(this)).catch(function(error) {

                        console.log("error resolve post")

                        reject(error);
                    }.bind(this))
                } else {
                    this.$axios.get(apiUrl, {
                        headers: headerData
                    }).then(function(result) {

                        resolve(result);

                    }.bind(this)).catch(function(error) {
                        console.log("error resolve post")

                        reject(error);

                    }.bind(this))
                }

            }.bind(this));
            return promise;
        },

        async downloadFiles(endpoint, type = 'post', payload = {}, header = null, showError = true, customEndpoint = false) {
            //    alert("callapimixin")
            var promise = new Promise(function(resolve, reject) {
                let headerData = header;

                //Only add authorization-header when backend is called
                if (header == null && !customEndpoint) {
                    headerData = {
                        'Accept': 'application/*',
                        'Authorization': 'Bearer ' + localStorage.bearertoken
                    }
                }
                let apiUrl = this.$backendURL + endpoint;
                if (customEndpoint) {
                    apiUrl = endpoint
                }
                if (type == 'post') {
                    this.$axios.post(apiUrl, payload, {
                        responseType: 'arraybuffer',

                        headers: headerData
                    }).then(function(result) {
                        console.log("resolve post")
                        resolve(result);

                    }.bind(this)).catch(function(error) {

                        console.log("error resolve post")

                        reject(error);
                    }.bind(this))
                } else {
                    this.$axios.get(apiUrl, {
                        responseType: 'arraybuffer',

                        headers: headerData
                    }).then(function(result) {

                        resolve(result);

                    }.bind(this)).catch(function(error) {
                        console.log("error resolve post")

                        reject(error);

                    }.bind(this))
                }

            }.bind(this));
            return promise;
        },

        HTTPRequest() {
            let callApi = this.callApi
            return {
                async getDeviceList() {
                    var promise = new Promise(function(resolve, reject) {
                        setTimeout(function() {
                            resolve();

                        }, 5000);
                    });
                    return promise;
                },
                //--- Sales --//
                async getSales() {
                    return callApi("/sales/get");
                },


                //--- Groups --//

                async getAllGroups() {
                    return callApi("/group/all")
                },

                async getNewGroupMessages() {
                    return callApi("/group/messages/new");
                },



                //--- User --//

                async getAllHighscoreData() {
                    return callApi("/user/highscore");
                },

                async getUserMessages() {
                    return callApi("/message/own");
                },

                //--- Announcements --//

                async getAnnouncements(amount = 5) {
                    let postData = {
                        amount: this.announcementCount
                    }
                    return callApi("/announcement/get", "post", postData)
                },


                //--- Sales --//

                async getOwnSales() {
                    return callApi("/sales/own");
                },

                async deleteSale(id) {
                    return callApi("/sales/" + id + "/delete", "post");
                },

                async closeSale(id) {
                    return callApi("/sales/" + id + "/close", "post");
                },




                //--- Calendar || Events ---//


                async getEvents(eventYear, eventMonth) {
                    let postData = {
                        year: eventYear + "",
                        month: eventMonth + ""
                    }
                    return callApi("/events/get", "post", postData)
                },

                async getParticipatedEvents(eventYear, eventMonth) {
                    let postData = {
                        year: eventYear + "",
                        month: eventMonth + ""
                    }
                    return callApi("/events/participated")
                },

                async joinEvent(id) {
                    return callApi("/events/" + id + "/join", "post")
                },

                async leaveEvent(id) {
                    return callApi("/events/" + id + "/leave", "post")
                },

                async getEventTypes() {
                    return callApi("/events/types");
                },
                //--- Nachbarschaftshilfe / NBH ---//
                async getAllNBHs() {
                    return callApi("/nbh/get")
                },

                async createNBH(title, description, reward, type = "nbh") {
                    var nbhData = {
                        "title": title,
                        'description': description,
                        'reward': reward,
                        'type': type
                    }
                    var postdata = {
                        "nbh": nbhData
                    }
                    return callApi("/nbh/create", "post", postdata)
                },

                async deleteNBH(id) {
                    return callApi("/nbh/" + id + "/delete", "post")
                },

                async resolveNBH(userId, nbhId) {
                    var postData = {
                        'helpedBy': userId
                    }
                    return callApi("/nbh/" + nbhId + "/resolve", "post", postData)
                },

                // ------------------------//
                //--- Serviceplattform ---//
                // ------------------------//


                //--- Idealer Vebrauch ---//

                async getIdealCOnsumption(dayTimestamp, token) {
                    var date = new Date(dayTimestamp);


                    var url = "https://incentivierungfunction.azurewebsites.net/api/Incentivierung_Trigger?von=1556017200&bis=1556018100&token=" + token
                }

            }
        }
    }
};